import { get, ref } from "firebase/database";
import * as actionType from "../../../../context/actions";
import { database } from "../../../../Utils/firebase";

const GetAssignerUserCustomerData = async (state, dispatch, sharedBusinesses = null) => {
    const owners = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];

    if (!owners.length) return [];

    try {
        const sharedCustomers = [];
        const customerMap = new Map();

        const ownerPromises = owners.map(async (owner) => {
            const ownerUid = owner.ownerUid;
            const companies = owner.companies || [];

            // Gather all allowed company IDs for this specific owner
            const allowedCompanyIds = companies.map(company => company.companyId || company.businessId || company.id);

            if (!allowedCompanyIds.length) return;

            const customerRef = ref(database, `invoiceGenerator/users/${ownerUid}/customers`);
            const snapshot = await get(customerRef);

            if (!snapshot.exists()) return;

            const data = snapshot.val();

            Object.entries(data).forEach(([id, info]) => {
                if (!info || !info.companyId || !info.customer) return;

                // STRICT LOCAL FILTER: ensure customer belongs to a shared company
                if (allowedCompanyIds.includes(info.companyId)) {
                    
                    const key = `${info.companyId}-${info.customer}-${ownerUid}`; // Added ownerUid to ensure unique keys across shared admins
                    const amount = parseFloat(info.totalAmount) || 0;
                    const totalPaid = parseFloat(info.totalPaid) || 0;

                    const rawDate = parseInt(info.creationDate || info.createdAt || Date.now());
                    const creationDate = rawDate.toString().length > 10 ? new Date(rawDate) : new Date(rawDate * 1000);

                    const invoices = Array.isArray(info.invoices)
                        ? info.invoices
                        : info.invoiceId
                            ? [info.invoiceId]
                            : [];

                    const ledger = Array.isArray(info.paymentsReceived)
                        ? info.paymentsReceived
                        : [];

                    customerMap.set(key, {
                        ...info, // Optional: preserve original fields as a fallback
                        customer: info.customer,
                        companyId: info.companyId,
                        dialCode: info.dialCode || info.dial_code,
                        phone: info.phone,
                        email: info.email,
                        customerGSTNo: info.customerGSTNo || null,
                        address: info.address || null,
                        invoices,
                        totalAmount: amount,
                        date: info.creationDate || info.createdAt,
                        latestDate: creationDate,
                        customerId: info.customerId || "",
                        totalPaid: totalPaid || 0,
                        uniqueId: id,
                        paymentsReceived: ledger,
                        isShared: true,
                        ownerUid: ownerUid
                    });
                }
            });
        });

        await Promise.all(ownerPromises);

        // Map them to an array
        const fetchedSharedCustomers = Array.from(customerMap.values()).map((item) => {
            const { latestDate, ...rest } = item;
            return rest;
        });

        return fetchedSharedCustomers;

    } catch (error) {
        console.error("Firebase AssignerUser Customer Fetch Error:", error);
        return [];
    }
};

export default GetAssignerUserCustomerData;
